<template>
  <b-row class="pr-3">
    <b-col cols="6" class="mb-4">
      <PageTitle title="Editar categoria" />
    </b-col>

    <b-col cols="6" class="mb-4 text-right">
      <button class="btn btn-primary" @click="addCategory()">
        Adicionar nova categoria
      </button>
    </b-col>

    <b-col cols="6" class="mb-2 mt-2">
      <label>Categoria: <span class="text-danger d-inline">*</span></label>
      <span class="ml-2"><b>{{categoria}}</b></span>
      <span class="btn btn-primary float-right mb-1" @click="limparCategoria()">Limpar</span>

      <select class="custom-select mb-3" @change="selectId()" v-model="categoriaSelect">
        <option selected value="">-- Selecione a categoria {{count+1}} --</option>
        <option v-for="(item, i) in categorias" :key="i" :value="item">
          {{item.nome_departamento}} | 
          Ordem: {{item.ordem}}
        </option>
      </select>
    </b-col>

    <b-col cols="6" class="mt-2 mb-2">
      <h4>Editar categoria selecionada:</h4>

      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th style="width: 50px">Foto</th>
            <th>Nome</th>
            <th class="text-center" style="width: 50px">Ordem</th>
            <th class="text-center" style="width: 105px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in categoriaSelecionada" :key="i">
            <td>
              <img
                v-if="item.photo && item.photo != ''"
                :src="`${getImagesAddressAppAws}` + item.photo" 
                width="30"
              >
            </td>
            <td>{{item.name}}</td>
            <td class="text-center" style="width: 50px">{{item.order ? item.order : 0}}</td>
            <td class="text-center" style="width: 105px">
              <span 
                class="btn btn-primary btn-sm"
                @click="editarCategoriaSelecionada(item)"
                v-b-tooltip.hover
                title="Editar"
              >
                <i class="fas fa-edit"></i>
              </span>

              <span 
                v-if="item.link == false"
                class="btn btn-dark btn-sm ml-2"
                @click="addCategory(item)"
                v-b-tooltip.hover
                title="Adicionar sub-categoria"
              >
                <i class="fas fa-plus"></i>
              </span>

              <span 
                v-if="item.link == true"
                class="btn btn-success btn-sm ml-2"
                @click="transferProductCategory(item)"
                v-b-tooltip.hover
                title="Transferir produtos para outra categoria"
              >
                <i class="fas fa-retweet"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>      
    </b-col>

    <b-col cols="12" class="mt-2 mb-2">
      <h4>Produtos da categoria selecionada:</h4>

      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th style="width: 50px">Foto</th>
            <th>Nome</th>
            <th class="text-center">Cód. barras</th>
            <th class="text-center">Marca</th>
            <th class="text-center">Preço</th>
            <th class="text-center" style="width: 105px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in products" :key="i">
            <td>
              <img 
                v-if="item.produto_fotos && item.produto_fotos[0]"
                :src="`${getImagesProductsAws}` + item.produto_fotos[0].foto_png" 
                width="30"
              >
            </td>
            <td>{{item.produto}}</td>
            <td class="text-center">{{item.codbar ? item.codbar : ''}}</td>
            <td class="text-center">{{item.marca ? item.marca : ''}}</td>
            <td class="text-center">{{item.price_sales_format_1 ? formatMoney(item.price_sales_format_1) : ''}}</td>
            <td class="text-center">
              <span 
                class="btn btn-success btn-sm ml-2"
                @click="transferProductCategory(item, true)"
                v-b-tooltip.hover
                title="Transferir produto para outra categoria"
              >
                <i class="fas fa-retweet"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>      
    </b-col>

    <b-modal
      :title="newCategoryPai != null ? 'Adicionar sub-categoria em ' + newCategoryPai.name : 'Adicionar categoria'"
      size="lg"
      id="modal-add-category"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12" class="mb-2" v-for="(item, i) in newCategory" :key="i">
          <b-row>
            <b-col cols="6">
              <label>Nome da {{i == 0 ? 'categoria' : 'sub-categoria'}}:</label>
              <input
                type="text"
                class="form-control"
                v-model="item.name"
                :placeholder="i == 0 ? 'Informe um nome para categoria' : 'Informe um nome para sub-categoria'"
              >
              <span v-if="item.name == ''" style="color:red">
                Informe o nome da {{i == 0 ? 'categoria' : 'sub-categoria'}}!
              </span>
            </b-col>

            <b-col cols="6">
              <label>Icone da {{i == 0 ? 'categoria' : 'sub-categoria'}}:</label>
              <input 
                v-if="item.icon == ''"
                type="file" 
                :id="'file'+i" 
                :ref="'file'+i" 
                accept="image/png" 
                @change="uploadImage(i)" 
                class="form-control"
              >
              <img v-if="item.icon != ''" :src="`${getImagesAddressAppAws}`+item.icon" width="50" class="ml-4" alt="Icone">
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" class="mt-3">
          <button class="btn btn-primary btn-block" @click="newCategory.push({name: '', icon: ''})">
            Adicionar sub-categoria
          </button>
        </b-col>

        <b-col cols="12" class="mt-3">
          <button class="btn btn-success btn-block" @click="saveNewCategory()">
            {{ newCategoryPai != null ? 'Criar nova sub-categoria' : 'Criar nova categoria'}}
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Editar categoria"
      size="md"
      id="modal-edit-category"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="9">
          <label>Nome:</label>
          <input type="text" class="form-control" v-model="editarCategoria.name">
        </b-col>

        <b-col cols="3">
          <label>Ordem:</label>
          <input type="text" class="form-control" v-model="editarCategoria.order" @change="formatOrder()">
        </b-col>

        <b-col cols="2" class="mt-3">
          <label>Foto:</label>
          <img :src="`${getImagesAddressAppAws}`+editarCategoria.photo" width="30">
        </b-col>

        <b-col cols="10" class="mt-3">
          <label>Nova imagem para categoria:</label>
          <input type="file" ref="editFile" id="editFile" class="form-control" accept="image/*" @change="uploadFile()">
        </b-col>

        <b-col cols="12" class="mt-3">
          <button class="btn btn-success btn-block" @click="save()">
            Atualizar categoria
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Transferir produto(s) de categoria"
      size="lg"
      id="modal-transfer-product-category"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12">
          <label>De:</label>
          <input type="text" class="form-control" :value="isProduct ? categoria : editarCategoria.name" disabled>
        </b-col>

        <b-col cols="12" class="mt-2">
          <label>Para:</label>
          <input type="text" class="form-control" v-model="syncCategoria" disabled>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
          <label>Categoria: <span class="text-danger d-inline">*</span></label>
          <span class="ml-2"><b>{{syncCategoria}}</b></span>
          <span class="btn btn-primary float-right mb-1" @click="syncLimparCategoria()">Limpar</span>

          <select class="custom-select mb-3" @change="syncSelectId()" v-model="syncCategoriaSelect">
              <option selected value="">-- Selecione a categoria {{syncCount+1}} --</option>
              <option v-for="(item, i) in syncCategorias" :key="i" :value="item">{{item.nome_departamento}}</option>
          </select>
        </b-col>

        <b-col cols="12" class="mt-2">
          <button class="btn btn-success btn-block" :disabled="syncSetLink == false" @click="updateProductsCategory()">
            {{isProduct ? 'Atualizar categoria do produto' : 'Atualizar produtos na categoria'}}
          </button>
        </b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';

export default {
    name: 'ShopkeeperEditCategory',
    mixins: [makeToast],
    components: { 
      PageTitle,
    },

data() {
  return {
    loading: false,
    setLink: false,
    syncSetLink: false,
    setIcon: null,
    newCategoryPai: null,
    categoryId: null,
    count: 0,
    syncCount: 0,
    categoriaSelect: '',
    syncCategoriaSelect: '',
    categoria: '',
    syncCategoria: '',
    newCategory: [],
    categorias: [],
    categoriaSelecionada: [],
    syncCategorias: [],
    products: [],
    isProduct: false,
    editarCategoria: {
      id: null,
      name: '',
      order: null,
      parentId: null
    },
  }
},

computed: {
  ...mapState(['dadosUsuario']),
  ...mapGetters('general', ['getImagesAddressAppAws', 'getImagesProductsAws'])
},

mounted() {
  this.getCategoriaLojista(0);
},

methods: {
  getCategoriaLojista(id) {
    const data = {
      categoriaId: id,
      lojistaId: this.dadosUsuario.id
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/buscarCategoriasLojista', data)
      .then((response) => {
        this.categorias = response.data;
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },

  getCategoria(id, isModal = false) {
    const data = {
      categoriaId: id,
      lojistaId: this.dadosUsuario.id
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/buscarCategoriasId', data)
      .then((response) => {
        this.syncCategorias = response.data;

        if(isModal) {
          this.$bvModal.show('modal-transfer-product-category');
        }
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },

  formatOrder() {
    if(this.editarCategoria.order < 0) {
      this.editarCategoria.order = 0;
      this.makeToast('Erro', 'O valor da ordem não pode ser negativo!', 'danger');
    }
  },

  save() {
    if(this.editarCategoria.name == '' && this.editarCategoria.photo == '' && this.editarCategoria.order == '') {
      this.makeToast('Erro', 'Informe pelo menos um valor para salvar!', 'danger');
      return;
    }

    const data = {
      categoria: this.editarCategoria,
      lojistaId: this.dadosUsuario.id
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/salvarCategoriaLojista', data)
      .then((response) => {
        if(response.data.type == 'success') {
          this.$bvModal.hide('modal-edit-category');
        }

        this.makeToast(response.data.title, response.data.text, response.data.type);
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },

  addCategory(id=null) {
    this.newCategoryPai = id;
    this.newCategory = [];

    this.newCategory.push({name: '', icon: ''});
    this.$bvModal.show('modal-add-category');
  },

  saveNewCategory() {
    const invalidCategory = this.newCategory.some(item => item.name === '');

    if (invalidCategory) {
        this.makeToast('Erro', 'Todos os campos de nome devem ser preenchidos!', 'danger');
        return;
    }

    const data = {
      categorias: this.newCategory,
      lojistaId: this.dadosUsuario.id,
      newCategoryPai: this.newCategoryPai
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/novaCategoriaLojista', data)
      .then((response) => {
        if(response.data.type == 'success') {
          this.$bvModal.hide('modal-add-category');

          this.limparCategoria();
        }

        this.makeToast(response.data.title, response.data.text, response.data.type);
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },

  uploadImage(i) {
    const fileRef = 'file' + i;
    const formData = new FormData();

    this.imageSelected = this.$refs[fileRef][0].files[0];
    formData.append('file', this.imageSelected);

    this.$store.dispatch('startLoader');
    this.$store.dispatch('files/uploadFileNewCategory', formData)
    .then((response) => {
      const file = response.data.data;
      this.newCategory[i].icon = file
    })
    .catch(() => {
      this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
    })
    .finally(() => {
      this.$store.dispatch('endLoader');
    });
  },

  uploadFile() {
    const fileRef = 'editFile';
    const formData = new FormData();

    const inputFile = this.$refs[fileRef];
    console.log(inputFile)
    if (!inputFile || !inputFile.files || !inputFile.files.length) {
      this.makeToast('Erro', 'Nenhum arquivo selecionado!', 'danger');
      return;
    }

    this.imageSelected = inputFile.files[0];
    formData.append('file', this.imageSelected);

    this.$store.dispatch('startLoader');
    this.$store.dispatch('files/uploadFileNewCategory', formData)
    .then((response) => {
      const file = response.data.data;
      this.editarCategoria.photo = file
    })
    .catch(() => {
      this.makeToast('Oops!', 'Não foi possível inserir a imagem, tente novamente!', 'danger');
    })
    .finally(() => {
      this.$store.dispatch('endLoader');
    });
  },
  formatMoney(value) {
    var money = parseFloat(value);
    return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
  },
  updateProductsCategory() {

    if(this.isProduct) {
      const data = {
        newCategory: this.syncCategoriaSelect.id,
        productId: this.editarCategoria.id,
        lojistaId: this.dadosUsuario.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/updateProductIdCategory', data)
        .then((response) => {
          if(response.data.type == 'success') {
            this.$bvModal.hide('modal-transfer-product-category');

            this.syncLimparCategoria();
            this.getProductCategory(this.categoryId);
          }

          this.makeToast(response.data.title, response.data.text, response.data.type);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    } else {
      const data = {
        newCategory: this.syncCategoriaSelect.id,
        oldCategory: this.editarCategoria.id,
        lojistaId: this.dadosUsuario.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/updateProductsCategory', data)
        .then((response) => {
          if(response.data.type == 'success') {
            this.$bvModal.hide('modal-transfer-product-category');

            this.limparCategoria();
            this.syncLimparCategoria();
          }

          this.makeToast(response.data.title, response.data.text, response.data.type);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    }
  },

  getProductCategory(categoryId) {

    this.categoryId = categoryId;

    const data = {
      categoryId: categoryId,
      lojistaId: this.dadosUsuario.id
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('shopkeeper/getProductCategoryShopkeeper', data)
      .then((response) => {
        this.products = response.data;
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },

  transferProductCategory(item, isProduct = false) {
    this.editarCategoria = item;
    this.isProduct= isProduct;

    this.getCategoria(0, true);
  },

  editarCategoriaSelecionada(item) {
    this.editarCategoria = item;

    this.$bvModal.show('modal-edit-category');
  },

  selectId() {
    const item = this.categoriaSelect;

    this.products = [];
    if(item && item.nome_departamento) {
      if(this.setLink == false) {
        const seta = this.count == 0 ? '' : ' -> ';            
        this.categoria = this.categoria+seta+item.nome_departamento;
      } else {
        const partes = this.categoria.split(' -> ');

        partes.pop();
        partes.push(item.nome_departamento);
        
        this.categoria = partes.join(' -> ');

        this.categoriaSelecionada.pop();
      }
    }

    this.categoriaSelecionada.push({
      id: item.id,
      order: item.ordem,
      name: item.nome_departamento,
      photo: item.imagem_departamento,
      link: item.link,
      parentId: item.departamento_pai_id 
    });

    if(item.link == true) {
      this.setLink = true;
      this.getProductCategory(item.id);
    } else {
      
      if(item && item.nome_departamento) {

        this.count = this.count +1;
        this.categoriaSelect = '';

        this.getCategoriaLojista(item.id);

        this.setLink = false;
      }
    }
  },

  syncSelectId() {
    const item = this.syncCategoriaSelect;

    if(item && item.nome_departamento) {
      if(this.syncSetLink == false) {
        const seta = this.syncCount == 0 ? '' : ' -> ';            
        this.syncCategoria = this.syncCategoria+seta+item.nome_departamento;
      } else {
        const partes = this.syncCategoria.split(' -> ');

        partes.pop();
        partes.push(item.nome_departamento);
        
        this.syncCategoria = partes.join(' -> ');
      }
    }

    if(item.link == true) {
      this.syncSetLink = true;
    } else {
      
      if(item && item.nome_departamento) {

        this.syncCount = this.syncCount +1;
        this.syncCategoriaSelect = '';

        this.getCategoria(item.id);

        this.syncSetLink = false;
      }
    }
  },

  limparCategoria() {
    this.setLink = false;
    this.count = 0;
    this.categoriaSelect = '';
    this.categoria = '';

    this.categoriaSelecionada = [];
    this.products = [];

    this.getCategoriaLojista(0);
  },

  syncLimparCategoria() {
    this.syncSetLink = false;
    this.syncCount = 0;
    this.syncCategoriaSelect = '';
    this.syncCategoria = '';

    this.getCategoria(0);
  }
}
}
</script>
